var tabs4i = function(){
	var tabLinks = [], 
	tabContent,
	findVisible = function(el){
		return el.offsetWidth > 0 || el.offsetHeight > 0;
	},
	init = function(element){
		var allTabs = element.getElementsByClassName("tabLink");
		for(var i = 0; i < allTabs.length; i++){
			var isVisible = findVisible(allTabs[i]);
			if(isVisible){
				tabLinks.push(allTabs[i]);
			}
		}
		tabContent = [].slice.call(element.getElementsByClassName("tabContent"));
		tabLinks.forEach(function(el, index, array){
			el.addEventListener("click", function(e){
				e.preventDefault();
				resetTabs();
	                	initTab(el);
			});
		});	
		tabKeys();
	},
	resetTabs = function(){
		tabLinks.forEach(function(el, index, array){ 
			el.parentNode.parentNode.classList.remove('active');
                	el.setAttribute('aria-selected', 'false');
                	el.setAttribute('tabindex', '-1');
		});
		tabContent.forEach(function(el, index, array){
                	el.classList.add('hide');
                	el.setAttribute('aria-hidden', 'true');
            	});
	},
	initTab = function(tabLink){ // select/show specific tab
		var targetContent = tabLink.getAttribute("data-content");
		tabLink.parentNode.parentNode.classList.add("active");
		tabLink.setAttribute("aria-selected", "true");
		tabLink.setAttribute("tabindex", "0");
		document.getElementById(targetContent).classList.remove("hide");		
		document.getElementById(targetContent).setAttribute("aria-hidden", "false");
	},
	tabKeys = function(){
		var firstTab = tabLinks[0];
		var lastTab = tabLinks[tabLinks.length-1];	
		tabLinks.forEach(function(el, index, array){
			var nextTab = array[index + 1];
			var prevTab = array[index - 1];
			el.addEventListener("keydown", function (e) {
				// Listen for the up, down, left and right arrow keys, otherwise, end here
				if ([37, 38, 39, 40].indexOf(e.which) == -1) { return; }
	            		if (document.activeElement == lastTab) {
	            			switch (e.which) {
			                	case 37: // left arrow
			                	case 38: // up arrow
			                    		e.preventDefault();
			                    		e.stopPropagation();
			                    		prevTab.focus(); // TODO get only visible sibling
			                        	prevTab.click();
			                    		break;
			                	case 39: // right arrow
			               	case 40: // down arrow
			                    		e.preventDefault();
			                   	 	e.stopPropagation();
		                        		firstTab.focus();
		                        		firstTab.click();
		                    }
	            		}else if (document.activeElement == firstTab) {
	            			switch (e.which) {
			                	case 37: // left arrow
			                	case 38: // up arrow
			                    		e.preventDefault();
			                    		e.stopPropagation();
		                        		lastTab.focus();
		                        		lastTab.click(); //focus on last and click
			                    		break;
			                	case 39: // right arrow
			               	case 40: // down arrow
			                    		e.preventDefault();
			                   	 	e.stopPropagation();
		                        		nextTab.focus();// TODO get only visible sibling
			                        	nextTab.click();
		            		}
	            		}else {
	            			switch (e.which) {
			                	case 37: // left arrow
			                	case 38: // up arrow
			                    		e.preventDefault();
			                    		e.stopPropagation();
			                        	prevTab.focus();// TODO get only visible sibling
			                        	prevTab.click();
			                    		break;
			                	case 39: // right arrow
			               	case 40: // down arrow
			                    		e.preventDefault();
			                   	 	e.stopPropagation();
			                    		nextTab.focus();// TODO get only visible sibling
			                        	nextTab.click();
		            		}
	            		}
			});
		});
	};
	
	return {
		init: init,
		initTab: initTab
	};
};